export const REQUEST_CAMPAIGN_LIST = "REQUEST_CAMPAIGN_LIST"
export const REQUEST_CAMPAIGN = "REQUEST_CAMPAIGN"